/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsIdParticipantsQueryResponse,
  GetTournamentsIdParticipantsPathParams,
} from "../types/GetTournamentsIdParticipants.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsIdParticipantsQueryKey = (
  id: GetTournamentsIdParticipantsPathParams["id"] | undefined,
) => [{ url: "/tournaments/:id/participants", params: { id: id } }] as const;

export type GetTournamentsIdParticipantsQueryKey = ReturnType<
  typeof getTournamentsIdParticipantsQueryKey
>;

/**
 * @summary Получение списка всех зарегистрированных участников турнира
 * {@link /tournaments/:id/participants}
 */
export async function getTournamentsIdParticipants(
  id: GetTournamentsIdParticipantsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsIdParticipantsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${id}/participants`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsIdParticipantsQueryOptions(
  id: GetTournamentsIdParticipantsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsIdParticipantsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTournamentsIdParticipantsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTournamentsIdParticipantsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsIdParticipants(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение списка всех зарегистрированных участников турнира
 * {@link /tournaments/:id/participants}
 */
export function useGetTournamentsIdParticipants<
  TData = ResponseConfig<GetTournamentsIdParticipantsQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsIdParticipantsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsIdParticipantsQueryKey,
>(
  id: GetTournamentsIdParticipantsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsIdParticipantsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTournamentsIdParticipantsQueryKey(id);

  const query = useQuery(
    {
      ...getTournamentsIdParticipantsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
